import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_TAGS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/tags`,
  {
    GET_LOAN_TAGS: 'GET_LOAN_TAGS',
    GET_LOAN_TAGS_ASSIGNMENTS_HISTORY: 'GET_LOAN_TAGS_ASSIGNMENTS_HISTORY',
    CREATE_LOAN_TAG_ASSIGNMENT: 'CREATE_LOAN_TAG_ASSIGNMENT',
    DELETE_LOAN_TAG_ASSIGNMENT: 'DELETE_LOAN_TAG_ASSIGNMENT',
    MANAGE_LOAN_TAG_ASSIGNMENT: 'MANAGE_LOAN_TAG_ASSIGNMENT',
  },
);
